import { useTranslation } from "react-i18next"
import { DateTime } from "luxon"
import { Transaction } from "@oysterhr/schema"
import { Badge, Table, Text } from "@oysterhr/ui"
import { SimpleMoney } from "@oysterhr/common"

interface TransactionTableProps {
  transactions: Transaction[]
}

export const TransactionsTable = ({ transactions }: TransactionTableProps) => {
  const { t } = useTranslation("components/payment_methods/Transactions")

  const statusPropsMap = {
    INITIALIZED: { text: t("statuses.initialized"), color: "gray" },
    ERROR: { text: t("statuses.initialized"), color: "gray" },
    PENDING: { text: t("statuses.pending"), color: "orange" },
    COMPLETED: { text: t("statuses.completed"), color: "green" },
    FAILED: { text: t("statuses.failed"), color: "red" },
    REFUNDED: { text: t("statuses.refunded"), color: "gray" },
    CANCELLED: { text: t("statuses.cancelled"), color: "gray" },
  }

  return (
    <Table>
      <Table.Head>
        <Table.Row>
          <Table.Header scope="col">{t("table.name_and_date")}</Table.Header>
          <Table.Header scope="col">{t("table.status")}</Table.Header>
          <Table.Header scope="col">{t("table.amount")}</Table.Header>
        </Table.Row>
      </Table.Head>
      <Table.Body>
        {transactions.map(transaction => (
          <Table.Row key={transaction.id}>
            <Table.Cell>
              <Text size="small" className="font-semibold">
                {transaction.invoiceName}
              </Text>
              <Text size="small">
                {DateTime.fromISO(transaction.createdAt).toLocaleString(DateTime.DATETIME_MED)}
              </Text>
            </Table.Cell>
            <Table.Cell>
              <Badge color={statusPropsMap[transaction.status].color}>
                {statusPropsMap[transaction.status].text}
              </Badge>
            </Table.Cell>
            <Table.Cell>
              <div className="text-md font-bold">
                {SimpleMoney.from({
                  subunit: -transaction.amount,
                  currencyCode: transaction.amountCurrencyCode,
                  subunitToUnit: 1,
                }).format()}
              </div>
              {transaction.bankNumberLast4 && (
                <div className="text-sm text-gray-400">******{transaction.bankNumberLast4}</div>
              )}
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  )
}
